module.exports = __webpack_public_path__ + "media/images/ln-img1-3dc69550063ade994b92956ff7e1b8ca.jpg";